// TaskRouter task_type values from task attributes.
// Used for inbound calls, callbacks, and call transfers (cold/warm).
// Transfer reservations: front-end receives reservation and must dial
// task_router:<task_sid>:<task_type>:<communication_id> on accept.
export const INBOUND_CALL = 'inbound_call'
export const CALLBACK = 'callback'
export const COLD_TRANSFER = 'cold_transfer'
export const WARM_TRANSFER = 'warm_transfer'

export const TRANSFER_TASK_TYPES = [COLD_TRANSFER, WARM_TRANSFER]
